<div class="popup-overlay" *ngIf="isVisible">
    <div class="popup-content">
      <h2>Error</h2>
      <p>{{ message }}</p>
      <p>Closing in {{ remainingTime }} seconds...</p>
    </div>
  </div>